import { render } from "./index.vue?vue&type=template&id=32504533&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=32504533&lang=scss&scoped=true"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32504533"]])

export default __exports__